
// 账户页
const configurationModule = () => import(/* webpackChunkName: "Index" */ '@/views/configurationModule/index')

const configurationRouter = [
    {
      path: '/index',
      redirect: '/admin/home',
      component: () => import('@/views/loginModule/index'),
      children: [
        {
          path: '/admin/configuration',
          name: 'configuration',
          component: configurationModule,
          meta: {
            title: '报表配置'
          },
          // children: [
          //   {
          //     path: '/admin/configuration/configurationSetting',
          //     name: 'configuration',
          //     component: () => import('@/views/configurationModule/configurationSetting'),
          //     meta: {
          //       title: '报表配置'
          //     },
          //   },]
        }
      ]
    }
  ]
  export default configurationRouter
